export enum DOCUMENTNATURE {
  TOUS = 'Tous',
  CONTRAT = 'Contrat',
  COLLABORATEURS = 'Collaborateurs',
  URSSAF = 'URSSAF',
  COTISATIONS = 'Cotisations',
  ARCHIVE = 'Archives'
}
